import React, { useState } from "react";

export const PayoffLetterContent = (props) => {
  let component = (
    <div>
      <div className="mb-3">Your 10-Day Payoff Letter is ready.</div>
      <button
        className="autopay-button-new d-flex m-auto"
        style={{ color: "white" }}
        onClick={() => {
          props.closeModal()
          props.callAuthGeneratePayoff(props.loan.AccountHash);
        }}
      >
        <i
          className="material-icons"
          style={{ alignSelf: "center", color: "white", width: "24px" }}
        >
          {"download_icon"}
        </i>
        <span className="pl-3">Download PDF</span>
      </button>
    </div>
  );

  return component;
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/modal/payoff-letter-content.component.js